/**
 * «Abonentlar» ekranidan KASSAGA o'tish shartnomasi — bitta joyda.
 *
 * <h2>⚠️ NEGA URL PARAMETRI, MARSHRUT HOLATI EMAS</h2>
 * `navigate(path, { state })` sahifa QAYTA YUKLANGANDA yo'qoladi va
 * o'shanda kassa tanlanmagan holda ochilardi — foydalanuvchi esa
 * «abonentni tanladim, panel unutdi» degan holatga tushardi. URL
 * parametri esa qayta yuklashdan ham, havolani nusxa olib yuborishdan
 * ham omon qoladi.
 *
 * <h2>⚠️ NEGA LOGIN, `id` EMAS</h2>
 * Kassa abonentni FAQAT katalog qidiruvi orqali topadi
 * (`GET /api/subscribers/directory?search=…`), u esa `login` prefiksi,
 * ism yoki telefon bo'yicha qidiradi — `id` bo'yicha qidiruv u yerda
 * UMUMAN yo'q (`SubscriberRepository.searchDirectory`). Ya'ni URL'ga
 * `id` yozilsa uni yechadigan endpoint qolmasdi, backendga esa
 * tegilmaydi (ADR-022).
 *
 * ⚠️ Qidiruv PREFIKS bo'yicha ishlagani uchun javobdan AYNAN teng
 * login tanlanadi (`usePreselectedSubscriber`): `ali` so'rovi `ali1`
 * ni ham qaytaradi va birinchi qatorni olish BOSHQA abonentni ochib
 * yuborardi — pul amali ekranida bu eng qimmat xato.
 */

/** Kassa ekrani — `router.tsx` dagi `<Route index>` */
export const CASHDESK_PATH = '/'

export const PRESELECT_LOGIN_PARAM = 'login'
export const PRESELECT_ACTION_PARAM = 'action'

/** Kassada darhol ochiladigan panel */
export type PreselectAction = 'fund' | 'grant'

export function cashdeskLink(login: string, action: PreselectAction): string {
  const params = new URLSearchParams({
    [PRESELECT_LOGIN_PARAM]: login,
    [PRESELECT_ACTION_PARAM]: action,
  })
  return `${CASHDESK_PATH}?${params.toString()}`
}

/**
 * URL'dagi xom qiymatni panel nomiga aylantiradi.
 *
 * ⚠️ Noma'lum qiymat `null` — «menyuni ko'rsat», xato emas. URL qo'lda
 * tahrirlanishi mumkin va noto'g'ri so'z uchun bo'sh ekran chiqarish
 * eng yomon javob bo'lardi.
 */
export function readPreselectAction(raw: string | null): PreselectAction | null {
  return raw === 'fund' || raw === 'grant' ? raw : null
}
